import http from "../http";


/**
 * 翻页查询库存信息
 */
export const getStockList = (currentPage, pageSize, data) => {
  return http({
    method: "post",
    url: `/stock/v2/stocks/page?currentPage=${currentPage}&pageSize=${pageSize}`,
    data
  });
};
/**
 * 根据销售码查库存信息
 */
export const getStockDetails = (codebars) => {
  return http({
    method: "get",
    url: `/stock/v2/stocks/codebars?codebars=${codebars}`
  });
};
/**
 * 查询所有的样本画册编码
 */
export const getbooknums = () => {
  return http({
    method: "get",
    url: `/stock/v2/booknums`
  });
};
/**
 * 根据画册编码，翻页查询库存信息
 */
export const getsearchbooknums = (currentPage, pageSize, bookNum,stockStatus,language) => {
  return http({
    method: "post",
    url: `/stock/v2/booknum/page?currentPage=${currentPage}&pageSize=${pageSize}&bookNum=${bookNum}&stockStatus=${stockStatus}&language=${language}`
  });
};

/**
 * 根据样本编码，翻页查询库存信息
 */
export const getsamplenums = () => {
  return http({
    method: "get",
    url: `/stock/v2/bunches`
  });
};

/**
 * 根据样本编码，翻页查询库存信息
 */
export const getsearchsamplenums = (currentPage, pageSize, bunchNum,stockStatus,language) => {
  return http({
    method: "post",
    url: `/stock/v2/bunchnum/page?currentPage=${currentPage}&pageSize=${pageSize}&bunchNum=${bunchNum}&stockStatus=${stockStatus}&language=${language}`
  });
};


/**
 * 根据列表看是否含有图片
 */
export const getsearchhasbook = (data) => {
  return http({
    method: "post",
    url: `https://qr.vitalitytex.com.cn/products/hasbook`,
    data
  });
};

/**
 * 根据信息导出elxcel
 */
//export const getexport = () => {
//return http({
//  method: "get",
//  url: `/book/v1/bunches`
//});
//};

/**
 * 翻页查询运单信息
 */
export const getDeliveyList = (invoiceNo) => {
  return http({
    method: "get",
    url: `openapi/do/v2/expressNumberQuery?invoiceNo=${invoiceNo}`,
  });
};